module.exports = require("querystring");


//////////////////
// WEBPACK FOOTER
// external "querystring"
// module id = 186
// module chunks = 0